export default class BusinessUnit {
    constructor(idInDB, externalId, name) {
        this.idInDB = idInDB;
        this.externalId = externalId;
        this.name = name;
    }

    static createFromData(data) {
        if (data == null) throw new Error("Cannot create BusinessUnit from data if data is null.");
        return new BusinessUnit(data.idInDB, data.externalId, data.name);
    }
}
